import { render, staticRenderFns } from "./BRadioWithValidation.vue?vue&type=template&id=1f90e842"
import script from "./BRadioWithValidation.vue?vue&type=script&lang=js"
export * from "./BRadioWithValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports